import { render } from "./content-footer-dinamic.vue?vue&type=template&id=f3e693da&scoped=true&lang=html"
import script from "./content-footer-dinamic.vue?vue&type=script&lang=js"
export * from "./content-footer-dinamic.vue?vue&type=script&lang=js"

import "./content-footer-dinamic.vue?vue&type=style&index=0&id=f3e693da&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e693da"]])

export default __exports__